/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import * as userAction from 'actions/components/user'

/**
 * Import Component
 */
import Confirmation from '../../components/scenes/Confirmation'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    user: state.user,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(userAction, dispatch),
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Confirmation)))



// WEBPACK FOOTER //
// ./src/containers/scenes/Confirmation.js